import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginateQuery, PaginatorModel, UUID } from 'symbols';
import { TYPE_SEARCH } from '../../symbols';
import {
  CompletedWorkFilterModel,
  CompletedWorkTransactionExpectBackend,
  CompletedWorkTransactionModel,
  SummaryCompletedWorkModel
} from '../symbols';

@Injectable()
export class CompletedWorkService {
  readonly apiUrl = '/api/completed-work';

  constructor(private http: HttpClient) {
  }

  getTransactionsByUserId(filter: PaginateQuery<CompletedWorkFilterModel>): Observable<PaginatorModel<CompletedWorkTransactionModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      typeSearch: TYPE_SEARCH.BY_METADATA,
      filter: filter?.filter
    };


    if (filter?.filter?.searchText) {
      params['search'] = filter?.filter?.searchText || '';
    }

    if (filter?.filter?.date) {
      params['filter.date'] = filter?.filter?.date || '';
    }
    return this.http.get<PaginatorModel<CompletedWorkTransactionModel>>(`${this.apiUrl}/transactions/${filter.filter?.userId}`, { params });
  }

  getTransactionsByUserIdLazy(next: string): Observable<PaginatorModel<CompletedWorkTransactionModel>> {
    return this.http.get<PaginatorModel<CompletedWorkTransactionModel>>(next);
  }

  getSummaryByUserId(userId: string, date: string): Observable<SummaryCompletedWorkModel> {
    const params: { [key: string]: any } = {};
    if (date) {
      params['date'] = date;
    }
    return this.http.get<SummaryCompletedWorkModel>(`${this.apiUrl}/summary/${userId}`, { params });
  }

  getSummaryGroupByUserId(date: string): Observable<SummaryCompletedWorkModel[]> {
    return this.http.get<SummaryCompletedWorkModel[]>(`${this.apiUrl}/workers`, { params: { date } });
  }

  createTransaction(transaction: CompletedWorkTransactionExpectBackend): Observable<CompletedWorkTransactionModel> {
    return this.http.post<CompletedWorkTransactionModel>(this.apiUrl, transaction);
  }

  updateTransaction(transaction: CompletedWorkTransactionExpectBackend, id: UUID): Observable<CompletedWorkTransactionModel> {
    return this.http.patch<CompletedWorkTransactionModel>(`${this.apiUrl}/${id}`, transaction);
  }

  deleteTransaction(id: UUID): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
